import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { Organization, OrganizationProjects, OrganizationUsers, Project, ProjectUsers } from '@models';
import { organizationProjectKey, organizationUserKey, projectUserKey } from '../join-keys';

export type WorkspaceStatus = 'idle' | 'loading' | 'ready' | 'error';

export interface WorkspaceState {
  projects: EntityState<Project>;
  organizations: EntityState<Organization>;
  orgProjects: EntityState<OrganizationProjects>;
  projectUsers: EntityState<ProjectUsers>;
  orgUsers: EntityState<OrganizationUsers>;
  selectedProjectId: string | null;
  selectedOrganizationId: string | null;
  status: WorkspaceStatus;
  error: string | null;
}

export const projectsAdapter = createEntityAdapter<Project>({ selectId: (p) => p.id ?? '' });
export const organizationsAdapter = createEntityAdapter<Organization>({ selectId: (o) => o.id ?? '' });
export const orgProjectsAdapter = createEntityAdapter<OrganizationProjects>({
  selectId: (op) => organizationProjectKey(op) || `${op.organizationId}:${op.projectId}`,
});
export const projectUsersAdapter = createEntityAdapter<ProjectUsers>({
  selectId: (pu) => projectUserKey(pu) || `${pu.projectId}:${pu.userId}`,
});
export const orgUsersAdapter = createEntityAdapter<OrganizationUsers>({
  selectId: (ou) => organizationUserKey(ou) || `${ou.organizationId}:${ou.userId}`,
});

export const initialWorkspaceState: WorkspaceState = {
  projects: projectsAdapter.getInitialState(),
  organizations: organizationsAdapter.getInitialState(),
  orgProjects: orgProjectsAdapter.getInitialState(),
  projectUsers: projectUsersAdapter.getInitialState(),
  orgUsers: orgUsersAdapter.getInitialState(),
  selectedProjectId: null,
  selectedOrganizationId: null,
  status: 'idle',
  error: null,
};
